var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6597 11.772L18.9687 20.751C19.0687 21.138 18.9277 21.547 18.6127 21.791C18.4327 21.93 18.2167 22 17.9997 22C17.8337 22 17.6667 21.959 17.5157 21.875L11.8357 18.733L6.50572 21.862C6.15872 22.064 5.72072 22.042 5.39872 21.799C5.07572 21.556 4.93072 21.143 5.03172 20.751L7.33972 11.772C6.50372 10.74 5.99972 9.429 5.99972 8C5.99972 4.691 8.69172 2 11.9997 2C15.3087 2 17.9997 4.691 17.9997 8C17.9997 9.429 17.4957 10.74 16.6597 11.772ZM11.9997 4C14.2057 4 15.9997 5.794 15.9997 8C15.9997 10.206 14.2057 12 11.9997 12C9.79372 12 7.99972 10.206 7.99972 8C7.99972 5.794 9.79372 4 11.9997 4ZM12.3057 16.707C11.9947 16.536 11.6187 16.539 11.3157 16.72L7.56772 18.92L9.03572 13.21C9.91072 13.71 10.9217 14 11.9997 14C13.0777 14 14.0887 13.71 14.9647 13.21L16.4537 19.002L12.3057 16.707Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9890_17896",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 14,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6597 11.772L18.9687 20.751C19.0687 21.138 18.9277 21.547 18.6127 21.791C18.4327 21.93 18.2167 22 17.9997 22C17.8337 22 17.6667 21.959 17.5157 21.875L11.8357 18.733L6.50572 21.862C6.15872 22.064 5.72072 22.042 5.39872 21.799C5.07572 21.556 4.93072 21.143 5.03172 20.751L7.33972 11.772C6.50372 10.74 5.99972 9.429 5.99972 8C5.99972 4.691 8.69172 2 11.9997 2C15.3087 2 17.9997 4.691 17.9997 8C17.9997 9.429 17.4957 10.74 16.6597 11.772ZM11.9997 4C14.2057 4 15.9997 5.794 15.9997 8C15.9997 10.206 14.2057 12 11.9997 12C9.79372 12 7.99972 10.206 7.99972 8C7.99972 5.794 9.79372 4 11.9997 4ZM12.3057 16.707C11.9947 16.536 11.6187 16.539 11.3157 16.72L7.56772 18.92L9.03572 13.21C9.91072 13.71 10.9217 14 11.9997 14C13.0777 14 14.0887 13.71 14.9647 13.21L16.4537 19.002L12.3057 16.707Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9890_17896)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.5d946e2116100f7e51dcc003dc4ac5b4.svg";
export { ForwardRef as ReactComponent };